import ContentBlock from './ContentBlock'
export type { ContentBlockProps } from './ContentBlock'
export default ContentBlock
